import NotificationSound from "./assets/sounds/OrderReceived.wav"

export const playSound = () => {
    const audio = new Audio(NotificationSound);
    audio.play().catch((error) => {
        console.error('Error playing sounds:', error);
    });
}
